import { useRecoilState } from 'recoil';
import { authAtom } from '_state';

export { useFetchWrapper };

/**
 * Thin wrapper over fetch that:
 *  - always sends the httpOnly session cookie (credentials: 'include')
 *  - auto-clears client auth state when the server reports an invalid/expired session
 *
 * Usage: const fetchWrapper = useFetchWrapper();
 *        const res = await fetchWrapper.get('/api/services');
 */
function useFetchWrapper() {
    const [, setAuth] = useRecoilState(authAtom);

    return {
        get:    request('GET'),
        post:   request('POST'),
        put:    request('PUT'),
        patch:  request('PATCH'),
        delete: request('DELETE'),
    };

    function request(method) {
        async function requestor(url, header, body) {
            const myHeaders = new Headers();
            if (header) myHeaders.append('Content-Type', header);
            const requestOptions = {
                method,
                mode: 'cors',
                headers: myHeaders,
                redirect: 'follow',
                credentials: 'include',
            };
            if (body) requestOptions.body = body;
            return await fetch(url, requestOptions);
        }

        return async (url, header, body) => {
            const response = await requestor(url, header, body);
            try {
                const rawjson = await response.clone().json();
                const authError = rawjson?.message?.name;
                if (rawjson?.status === 'Error' &&
                    (authError === 'TokenNotFound' || authError === 'TokenInvalid' || authError === 'UserNotFound')) {
                    setAuth(null);
                    localStorage.removeItem('mh_userData');
                }
            } catch (_) {
                // Body is not JSON (file download, plain text) — fine.
            }
            return response;
        };
    }
}
